export default __webpack_public_path__ + "static/media/mad-ape-012.0c312cb7.svg";